import {
  unregisterIcons,
  registerIcons,
  initializeIcons,
} from "@fluentui/react";

import {
  PasswordHide,
  PasswordReveal,
  ChevronDown,
  Save,
  Cancel,
  ChevronLeft,
  ChevronRight,
  SidebarToggle,
  DashboardIcon,
  CompanySettingsIcon,
  UserSettings,
  LogOut,
  Edit,
  Delete,
  Company,
  Upload,
  Search,
} from "../assets/icons/index";

function useIcons() {
  initializeIcons();

  unregisterIcons([
    "RedEye",
    "hide",
    "ChevronDown",
    "Save",
    "Cancel",
    "ChevronLeft",
    "ChevronRight",
    "DoubleChevronLeft",
    "Chart",
    "SingleColumnEdit",
    "MuteChat",
    "MapPin",
    "Settings",
    "PlayerSettings",
    "PowerButton",
    "Edit",
    "Delete",
    "CloudUpload",
    "Filter",
    "TeamsLogoInverse",
    "Search",
  ]);

  registerIcons({
    icons: {
      RedEye: <PasswordHide />,
      hide: <PasswordReveal />,
      ChevronDown: <ChevronDown />,
      Save: <Save />,
      Cancel: <Cancel />,
      ChevronRight: <ChevronRight />,
      ChevronLeft: <ChevronLeft />,
      DoubleChevronLeft: <SidebarToggle />,
      Chart: <DashboardIcon />,
      Settings: <CompanySettingsIcon />,
      PlayerSettings: <UserSettings />,
      PowerButton: <LogOut />,
      Edit: <Edit />,
      Delete: <Delete />,
      TeamsLogoInverse: <Company />,
      CloudUpload: <Upload />,
      Search: <Search />,
    },
  });
}

export default useIcons;
